import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let adRulesMountPromise = null;

export function initAdRulesViewFragment({ onMounted } = {}) {
  registerViewMount('admin-ad-rules', () => mountAdRulesView(onMounted));
}

async function mountAdRulesView(onMounted) {
  if (document.getElementById('view-admin-ad-rules')) return;
  if (adRulesMountPromise) return adRulesMountPromise;

  adRulesMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/ad-rules.html', 'Unable to load ad rules view');
    onMounted?.();
  })();

  try {
    await adRulesMountPromise;
  } catch (error) {
    adRulesMountPromise = null;
    throw error;
  }
}
